module.exports = __webpack_public_path__ + "img/whatsapp-icon-desktop-zh-HK.fea7645.png";